<template>
   <div class="menu">
       <div class="menu_left">
           <div class="menu_left_top">
               <div class="menu_left_top_edit">
                   <img class="menu_left_top_edit_img" src="../assets/edit_icon.png" @click="editUser()">
                   <span @click="editUser()">编辑</span>
               </div>
               <div class="menu_left_top_img">
                    <img v-if="user.avatar" :src="$imgUrl + user.avatar" alt="">
                    <img v-else src="../assets/default_user.png" alt="">
               </div>
               <div class="menu_left_top_name">{{user.username}}</div>
               <div class="menu_left_top_content">
                   <div style="width:60%">
                       <p  class="menu_left_top_content_title">钱包余额</p>
                       <p class="menu_left_top_content_num">¥{{user.total_money}}</p>
                   </div>
                   <div  style="width:40%">
                       <p class="menu_left_top_content_title">邀请人数</p>
                       <p class="menu_left_top_content_num">{{user.invitation_num}}</p>
                   </div>
               </div>
           </div>
           <div class="menu_left_bottom">
               <ul>
                   <li class="menu_left_bottom_item" :class="{'menu_select':item.path == selectPath || item.childrenPath.indexOf(selectPath) != -1}" @click="goRouter(item.path)" v-for="(item,index) in menuData" :key="index">{{item.name}}</li>
               </ul>
           </div>
       </div>
       <div class="menu_right">
           <router-view></router-view>
       </div>
   </div>
</template>

<script>
export default {
   data (){
       return {
           menuData:[
               {name:'消息提醒',path:'/message',childrenPath:['/systemMessage','/messageDetails','/payMessage']},
               {name:'我的钱包',path:'/wallet',childrenPath:["/withdrawal"]},
               {name:'我的订单',path:'/orderList',childrenPath:["/orderDetails"]},
               {name:'地址薄',path:'/address',childrenPath:['/add_address']},
               {name:'优惠券',path:'/coupon',childrenPath:[]},
               {name:'邀请返现',path:'/invitation',childrenPath:[]},
            //    {name:'同行认证',path:'/authentication',childrenPath:[]}
           ],
           selectPath:'',
           userMessage:{
               user:{}
           },
           user:{}
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       editUser(){
           this.$router.push({path:'/edit_user'});
       },
       goRouter(path){
           if(this.selectPath == path){
               return;
           }
           this.$router.push({path:path});
       },
       getUserInfo(){
           this.$get('UserInfo',{})
            .then(data => {
                this.user = data;
            } , error => {
                this.$message.error(error);
            });
       }
   },
   updated(data){
        if(this.selectPath != this.$route.path){
            this.getUserInfo();
        }
       this.selectPath = this.$route.path;
   },
   created() {
       this.selectPath = this.$route.path;
       this.userMessage = JSON.parse(localStorage.getItem('userMessage') || '{}');
        this.$eventBus.$on('changeUserInfo' , data => {
            this.userMessage = data;
            if(Object.keys(data).length > 0){
                this.getUserInfo();
            }
            
        });
        this.$eventBus.$on('getUserInfo' , data => {
            this.getUserInfo();
        });
   },
   mounted() {
       
       this.getUserInfo();
   }
}
</script>

<style scoped lang='less'>
.menu{
    width:100%;
    padding: 24px calc(50% - 590px);
    display: flex;
    justify-content:space-between;
    background: #F5F5F5;
    &_left{
        width:280px;
        &_top{
            width:100%;
            height: 278px;
            background: #fff;
            margin-bottom:24px;
            &_edit{
                padding-right:16px;
                padding-top:16px;
                text-align: right;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                
                &_img{
                    width:28px;
                    height: 28px;
                    cursor: pointer;
                }
                span{
                    font-size: 16px;
                    color:#999;
                    padding-left: 4px;
                    cursor: pointer;
                }
                
            }
            &_img{
                text-align: center;
                margin-top:12px;
                margin-bottom:4px;
                img{
                    width:90px;
                    height: 89px;
                    border-radius: 45px;
                }
                
            }
            &_name{
                font-size: 24px;
                color:#333;
                font-weight: 500;
                text-align: center;
            }
            &_content{
                text-align: center;
                display: flex;
                margin-top:16px;
                div{
                    width:50%;
                }
                &_title{
                    font-size:14px;
                    color:#999;
                    margin:6px 0;
                }
                &_num{
                    font-size:18px;
                    color:#333333;
                    font-weight: 600;
                }
            }
        }
        &_bottom{
            width:100%;
            height: 402px;
            background: #fff;
            padding: 22px 0;
            &_item{
                height: 40px;
                font-size:20px;
                line-height: 40px;
                color:#666666;
                border-left: 8px solid #fff;
                cursor: pointer;
                padding-left:22px;
                margin:10px 0;
            }
            &_item.menu_select{
                font-weight: 600;
                color:#333333;
                border-left: 8px solid #5999FF;
            }
        }
    }
    &_right{
        width:880px;
        background:#fff;
        padding:20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/menu.vue